import { jsx as e } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 8.26778C7.16835 8.2561 7.08488 8.25006 7 8.25006H5C4.0335 8.25006 3.25 9.03356 3.25 10.0001V19.0001C3.25 19.9666 4.0335 20.7501 5 20.7501H7C7.08488 20.7501 7.16835 20.744 7.25 20.7323V8.26778ZM8.75 20.7501H16.9914C18.2192 20.7501 19.2983 19.9361 19.6356 18.7556L21.8541 10.9909C22.175 9.86768 21.3263 8.75136 20.1581 8.7602L14.0924 8.80609C14.5653 7.2637 14.4988 6.04392 14.0318 5.08714C13.471 3.9381 12.4248 3.36314 11.5936 3.05251C10.693 2.71594 9.79607 3.23994 9.4761 4.02093L8.75 5.79325V20.7501Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
